export enum PersonRoles {
    Reader = 'READER',
    Translator = 'TRANSLATOR',
    Author = 'AUTHOR',
  }
  